import FileInput from './file-input';
export default FileInput;
